import Footer from "../../components/footer"
import FooterBrand from "../../components/footerBrand"
import Header from "../../components/header"
import StudentReviews from "../../components/studentReviews"
import SlideCourse from "../../components/slideCourse"
import IntroductionPersonal from "../../components/courseDetail/introductionPersonal"
import InterestingTopic from "../../components/courseDetail/interestingTopic"
import Suitable from "../../components/courseDetail/suitable"
import Sale from "../../components/courseDetail/sale"
import UpperHeader from "../../components/courseDetail/upperHeader"
import { ResponseData, ResponseDataList } from "../../apiStrapi/models/data"
import { CourseContent, Contents } from "../../apiStrapi/models/contentType/courses"
import { strapiImage } from "../../apiStrapi/models/contact"
import YoutubeEP from "../../components/courseDetail/youtubeEP"
import CourseHeader from "../../components/courseDetail/courseHeader"
import { SingleCourse } from "../../apiStrapi/models/contentType/singleCourse"
import { AnnualPromotionContent } from "../../apiStrapi/models/contentType/annualPromotion"
import EpisodeAccordion from "../../components/courseDetail/episodeAccordion"
import { ReviewContent } from "../../apiStrapi/models/contentType/review"
import { CarouselContent } from "../../apiStrapi/models/contentType/carousel"
import {
  coursesAllApi,
  carouselApi,
  singleCourseApi,
  annualPromotionApi,
  findCourseBySlug,
  reviewApi,
} from "../../apiStrapi/StrapiApiService"
import MetaDescription from "../../components/metaDescription";


interface CourseDetailParams {
  courseSlug: string;
}

interface CourseDetailProps {
  carousel: ResponseDataList<CarouselContent>;
  course: CourseContent;
  singleCourse: ResponseData<SingleCourse>;
  annualPromotion: ResponseData<AnnualPromotionContent>;
  review: ResponseData<ReviewContent>;
}

export default function CourseDetail({
  carousel,
  course,
  singleCourse,
  annualPromotion,
  review }: CourseDetailProps) {
  const youtubeEPItems = course?.contents?.find((value) => {
    return value.__component === "components.special-ep-component"
  }) as Contents;
  const filterCarousel = carousel.data.filter(
    (item) => item?.attributes?.course?.data?.id !== course?.id
  );
  const settings = {
    slidesToShow: 4, slidesToScroll: 1, responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 776,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 475,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  }

  return <>
      <MetaDescription data={course?.meta_data} />
      <div className="course-detail">
        <Header />
        <div className="tb-sizer" >
          {course?.header && (
            <UpperHeader header={course?.header} />
          )}
          <CourseHeader yearlySubscriptionImage={strapiImage(annualPromotion.data?.attributes?.image?.data?.attributes?.url)}
                        singleCourseImage={strapiImage(singleCourse?.data?.attributes?.image?.data?.attributes?.url)}
                        secondaryImage={strapiImage(annualPromotion.data?.attributes?.image_secondary?.data?.attributes?.url)}
                        teaserVideo={course?.teaser_video}
                        singleCheckoutSku={course?.checkout_url}
                        yearlySubscriptionCheckoutSku={annualPromotion?.data?.attributes?.checkout_url}
                        yearlySubscriptionImageMobile={strapiImage(annualPromotion?.data?.attributes?.image_mobile?.data?.attributes?.url)}
          />
          {youtubeEPItems?.special_ep?.length > 0 && (
            <YoutubeEP YoutubeEPItems={youtubeEPItems.special_ep} />
          )}
          {course?.contents?.map((value, index) => {
            if (value.__component === "components.speaker-detail-component") {
              return (
                <IntroductionPersonal key={index} fullName={course?.speaker_name} speakerDetails={value?.speaker_detail} />
              )
            }
            if (value.__component === "components.topic-component") {
              return (
                <InterestingTopic key={index} interestingTopics={value?.topics} />
              )
            }
            if (value.__component === "components.suitable-component") {
              return (
                <Suitable key={index} suitable={value?.items} />
              )
            }
          })}
          <EpisodeAccordion totalHours={course?.total_hours}
                            totalEpisodes={course?.total_lessons}
                            episodes={course?.episodes} annualPromotion = {annualPromotion} />
        </div>
        <Sale singleCoursePersonalImage={strapiImage(course?.order_image?.url)}
              yearlySubscriptionImage={strapiImage(annualPromotion.data?.attributes?.image?.data?.attributes?.url)}
              yearlySubscriptionImageMobile={strapiImage(annualPromotion.data?.attributes?.image_mobile?.data?.attributes?.url)}
              singleCheckoutSku={course?.checkout_url}
              yearlySubscriptionCheckoutSku={annualPromotion.data?.attributes?.checkout_url} />
        <div className="background-light">
          <div className="sizer">
            <div className="container">
              <div className="row align-items-center justify-content-center">
                <div className="block-type-text text-center col-12 p-0 m-t-0">
                  <div className="block box-shadow-none">
                    <h2 className="text-center header-text color-primary">
                      คอร์สอื่น ๆ จาก &quot;ที่สุด&quot;
                      <br className="lg-none" />
                      ของประเทศอีกมากมาย
                    </h2>
                  </div>
                </div>
                <div className="block-type-code text-left col-12"  >
                  <SlideCourse settings={settings} slideCourses={filterCarousel} slideView={4} imageWidth={235} imageHeight={470.533} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="background-dark">
          <StudentReviews reviewStudents={review.data?.student} />
        </div>
        <FooterBrand />
        <Footer />
      </div>
  </>
}

export async function getStaticPaths() {
  const data = await coursesAllApi();
  const dataFilter = (data.data?.filter((value) => {
    return value
  }));
  const paths = dataFilter?.map((value) => {
    return {
      params: {
        courseSlug: value.slug,
      }
    }
  });
  return {
    paths: paths || [],
    fallback: false,
  };
}

export async function getStaticProps({ params }: { params: CourseDetailParams }) {
  return {
    props: {
      carousel: await carouselApi(),
      course: await findCourseBySlug(params.courseSlug) as CourseContent,
      singleCourse: await singleCourseApi(),
      annualPromotion: await annualPromotionApi(),
      review: await reviewApi(),
    }
  };
}
